<template>
  <AnalyticsWidget
    title="Late Orders Log"
    subTitle="List of recent late orders that were caused internally"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">
    <div class="p-2 h-100">
      <LoadingPanel :loading="loading" />
      <Scroller maxHeight="500" height="500">
        <AnalyticsBreakdownTable v-if="!loading">
          <template v-slot:header>
            <tr>
              <th>Order</th>
              <th>Contact</th>
              <th>Due</th>
              <th>Completed</th>
              <th>Reason</th>
              <th>Lateness</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="orderInfo of lateOrderList" :key="orderInfo.id">
              <td class="font-weight-bold"><LinkOrder :id="orderInfo.id" :name="orderInfo.sequenceNumber" /></td>
              <td><LinkContact :id="orderInfo.contact.id" :name="orderInfo.contact.name" /></td>
              <td>{{ formatDate(orderInfo.dateCurrentlyDue) }}</td>
              <td>{{ formatDate(orderInfo.dateClosed) }}</td>
              <td>{{ formatLookupName(orderInfo.operationalReportingCode, ItemOperationalReportingCodeLookup) }}</td>
              <td>{{ orderInfo.latenessDays }}d</td>
            </tr>            
          </template>
        </AnalyticsBreakdownTable>          
      </Scroller>
    </div>
  </AnalyticsWidget>
</template>

<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsBreakdownTable from '@/modules/intelligence/components/analyticsBreakdownTable'
import AnalyticsBreakdownValueCell from '@/modules/intelligence/components/analyticsBreakdownValueCell'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'
import ReportFilterGroup from '@/components/reporting/reportFilterGroup'

import { ItemOperationalReportingCodeLookup, OperationalReportingResultTypes } from '@/store/types'

export default {
  name: 'OrderDIFOTLateOrderListWidget',
  components: {
    AnalyticsWidget,
    AnalyticsBreakdownTable,
    AnalyticsBreakdownValueCell,
    ReportFilterPopover,
    ReportDateRangeSelect,
    ReportFilterGroup
  },
  props: {
    contactId: Number,
    filter: Object,
    gridWidth: Number,
    gridHeight: Number,
  },
  data() {
    return {
      loading: false,
      lateOrderList: []
    }
  },
  computed: {
    
  },
  watch: {
    contactId: function() {
      this.requestData()
    },
    filter: function() {
      this.requestData()
    }
  },
  created() {
    this.ItemOperationalReportingCodeLookup = ItemOperationalReportingCodeLookup
  },
  mounted() {
    this.requestData()

    this.subscribeEndpoint('/orders', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/orders')
  },
  methods: {
    requestData() {
      this.loading = true

      var params = {
        contactId: this.contactId,
        accountLocationId: this.filter ? this.filter.accountLocationIdList : null,
        maxOrderCount: 20
      }

      this.$apiService.analyticsService.getOrderDIFOTLateList(params)
      .then((response) => {
        this.lateOrderList = response.data || []
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
    },
  }
}
</script>
